export default __webpack_public_path__ + "static/pdp--product-3-32e85d706cdded124cd5193df40c34ba.jpg";